import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'

export const setOtherSpend = (basicInfo: IFormPartnerBasicInfo) => {
  if (basicInfo.A3TopVendorBrand1 === 'HP') {
    basicInfo.A3TopVendorBrand1Spend =
      Number(ValidationHelper.calcPercent(basicInfo.A3HP, basicInfo.A3AllBrands, true)) / 100
  } else if (basicInfo.A3TopVendorBrand2 === 'HP') {
    basicInfo.A3TopVendorBrand2Spend =
      Number(ValidationHelper.calcPercent(basicInfo.A3HP, basicInfo.A3AllBrands, true)) / 100
  } else if (basicInfo.A3TopVendorBrand3 === 'HP') {
    basicInfo.A3TopVendorBrand3Spend =
      Number(ValidationHelper.calcPercent(basicInfo.A3HP, basicInfo.A3AllBrands, true)) / 100
  }

  if (basicInfo.A4TopVendorBrand1 === 'HP') {
    basicInfo.A4TopVendorBrand1Spend =
      Number(ValidationHelper.calcPercent(basicInfo.A4HP, basicInfo.A4AllBrands, true)) / 100
  } else if (basicInfo.A4TopVendorBrand2 === 'HP') {
    basicInfo.A4TopVendorBrand2Spend =
      Number(ValidationHelper.calcPercent(basicInfo.A4HP, basicInfo.A4AllBrands, true)) / 100
  } else if (basicInfo.A4TopVendorBrand3 === 'HP') {
    basicInfo.A4TopVendorBrand3Spend =
      Number(ValidationHelper.calcPercent(basicInfo.A4HP, basicInfo.A4AllBrands, true)) / 100
  }

  const otherSpendA3 =
    1 -
    Number(basicInfo.A3TopVendorBrand1Spend ?? 0) -
    Number(basicInfo.A3TopVendorBrand2Spend ?? 0) -
    Number(basicInfo.A3TopVendorBrand3Spend ?? 0)

  const otherSpendA4 =
    1 -
    Number(basicInfo.A4TopVendorBrand1Spend ?? 0) -
    Number(basicInfo.A4TopVendorBrand2Spend ?? 0) -
    Number(basicInfo.A4TopVendorBrand3Spend ?? 0)

  return {
    ...basicInfo,
    A3TopVendorBrandOtherSpend: otherSpendA3,
    A4TopVendorBrandOtherSpend: otherSpendA4,
  }
}
